/*=========================================================================================
  File Name: moduleAttackActions.js
  Description: Attack Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import network from '../../http/requests/network/index.js'

export default {
    fetchListOfAttackHistory({ commit }, networkID) {
        return new Promise((resolve, reject) => {
          network.
            getListOfAttackHistory(networkID)
            .then(response => {
              commit('SET_ATTACKS', response.data);
              resolve(response);
            })
            .catch(error => {
              reject(error);
            })
        })
    },
    fetchAttackDetails({ commit }, attackDetails) {
        return new Promise((resolve, reject) => {
          network.
            getListOfAttackDetails(attackDetails)
            .then(response => {
              console.log('response', response)
              commit('SET_ATTACKHISTORY', response.data);
              resolve(response);
            })
            .catch(error => {
              reject(error);
            })
        })
    },
    fetchDroppedEvents({ commit }, attackEvents) {
      return new Promise((resolve, reject) => {
        network.
        getDroppedEventsDetails(attackEvents)
          .then(response => {
            commit('SET_DROPPED_EVENTS', response.data);
            resolve(response);
          })
          .catch(error => {
            reject(error);
          })
      })
  },
    fetchWebhookDetails({commit}, networkID) {
      return new Promise((resolve, reject) => {
        network.
          getWebhookDetails(networkID)
          .then(response => {
            commit('SET_WEBHOOKS', response.data);
            resolve(response);
          })
          .catch(error => {
            reject(error);
          })
      })
    },
    updateWebhookDetails({commit}, webhookPayload) {
      return new Promise((resolve, reject) => {
        network.
        updateWebhookDetails(webhookPayload)
          .then(response => {
            commit('SET_WEBHOOKS', response.data);
            resolve(response);
          })
          .catch(error => {
            reject(error);
          })
      })
    }
}